import styled from "styled-components"


interface PermissionProps{
    defaultChecked:boolean
    name:string,
    label:string,
    onChange:(event: React.ChangeEvent<HTMLInputElement>) => void
}

const Permission = ({label, name, defaultChecked, onChange}:PermissionProps) => {
    return(
        <Container>
            <Label>{label}</Label>
            <Radios>
                <RadioWrap>
                    <Radio type="radio" name={name} onChange={onChange} value={'true'} checked={defaultChecked}/>
                    <Label>Y</Label>
                </RadioWrap>
                <RadioWrap>
                    <Radio type="radio" name={name} onChange={onChange} value={'false'} checked={!defaultChecked}/>
                    <Label>N</Label>
                </RadioWrap>
            </Radios>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`
const Label = styled.label`
    color: #434343;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
`

const Radios = styled.div`
    display: flex;
    gap: 20px;
`
const RadioWrap = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`

const Radio = styled.input`
    width: 20px;
    height: 20px;
`


export default Permission;